let configs = [
  {
    code: 1,
    title: "Listas de campos",
    list: [
      {
        code: 1,
        title: "Cuentas aliadas",
        path: "configuraciones/cuenta-aliada",
      },
      {
        code: 2,
        title: "Subproyectos",
        path: "configuraciones/subproyectos",
      },
    ]
  },
]

export default configs
